import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { io } from 'socket.io-client';
import { SocketContext } from './SocketContext';

import KanbanView from './KanbanView';
import ChatInterface from './ChatInterface';
import SettingsPage from './SettingsPage';
import Dashboard from './Dashboard';
import AvailabilityPage from './pages/AvailabilityPage';
import PricingPage from './PricingPage';
import './App.css';

const socket = io('https://adam.app.autofront.com.au');

function App() {
    const [showConsole, setShowConsole] = useState(false);

    useEffect(() => {
        socket.on('connect', () => {
            console.log('🔌 Connected to socket');
        });
        return () => {
            socket.disconnect();
        };
    }, []);

    return (
        <SocketContext.Provider value={socket}>
            <Router>
                <nav className="navbar">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <Link to="/">Conversation View</Link>
                        <Link to="/settings">Settings</Link>
                        <Link to="/dashboard">Dashboard</Link>
                        <Link to="/pricing">Pricing</Link>
                        <Link to="/availability">Availability</Link>
                    </div>

                    <div style={{ marginLeft: 'auto', display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <button
                            onClick={() => setShowConsole((prev) => !prev)}
                            style={{
                                backgroundColor: showConsole ? '#e74c3c' : '#2ecc71',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                padding: '6px 12px',
                                cursor: 'pointer'
                            }}
                        >
                            {showConsole ? 'Hide Console' : 'Show Console'}
                        </button>
                    </div>
                </nav>

                <Routes>
                    <Route path="/" element={<KanbanView showConsole={showConsole} setShowConsole={setShowConsole} />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/pricing" element={<PricingPage />} />
                    <Route path="/availability" element={<AvailabilityPage />} />
                </Routes>
            </Router>
        </SocketContext.Provider>
    );
}

export default App;
